import SignDocumentsStepProcessor from './SignDocumentsStepProcessor';

export default SignDocumentsStepProcessor;
